// src/hooks/useEnFabrication.ts — SCE Issues
// La liste des équipements en fabrication (05/10), lue une fois par session et
// partagée par toutes les pages qui la montrent. Après une mise à jour depuis
// /admin, `publierEnFabrication` la diffuse aux composants montés.

import { useEffect, useMemo, useState } from 'react'
import { lireEnFabrication } from '@/api/enFabrication.api'
import { clesEnFabrication, type ListeEnFabrication } from '@/utils/enFabrication'

let promesse: Promise<ListeEnFabrication | null> | null = null
const abonnes = new Set<(liste: ListeEnFabrication | null) => void>()

/** La liste lue une fois par session (aussi pour les files de l’accueil qui en ont besoin). */
export function charger(): Promise<ListeEnFabrication | null> {
  // Un échec de lecture ne doit pas casser la page Équipements : pas de repère, c'est tout.
  promesse ??= lireEnFabrication().catch(() => null)
  return promesse
}

/** Après une écriture : la nouvelle liste, tout de suite, partout. */
export function publierEnFabrication(liste: ListeEnFabrication): void {
  promesse = Promise.resolve(liste)
  for (const f of abonnes) f(liste)
}

export interface EtatEnFabrication {
  liste: ListeEnFabrication | null
  /** Clés de rapprochement des N° de série en fabrication. */
  cles: Set<string>
  chargement: boolean
}

export function useEnFabrication(): EtatEnFabrication {
  const [liste, setListe] = useState<ListeEnFabrication | null>(null)
  const [chargement, setChargement] = useState(true)

  useEffect(() => {
    let actif = true
    void charger().then((l) => {
      if (!actif) return
      setListe(l)
      setChargement(false)
    })
    const abonne = (l: ListeEnFabrication | null): void => setListe(l)
    abonnes.add(abonne)
    return () => {
      actif = false
      abonnes.delete(abonne)
    }
  }, [])

  const cles = useMemo(() => clesEnFabrication(liste), [liste])
  return { liste, cles, chargement }
}
